import { Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";

import { BalanceRolledUpResponse } from "../../../api/useGetBalanceRollupDetails";
import { balancesEnumToLabel } from "../../../utils/balancesEnumToLabel";
import { getCurrencyValue } from "../../CallAlertsAuxWindow/auxUtils";
import {
  getFormatAndSumRollupData,
  getTotalSum,
} from "./utils/balanceRollupTools";

type RollupProps = {
  rollupData: BalanceRolledUpResponse;
};

export default function BalanceRollupTable({ rollupData }: RollupProps) {
  const accountTypes = getFormatAndSumRollupData(rollupData);

  const grandTotalTrade = getTotalSum(accountTypes, "convertedTradeBalance");
  const grandTotalSettled = getTotalSum(accountTypes, "convertedSettleBalance");

  return (
    <>
      <Thead>
        <Tr>
          <Th>Type</Th>
          <Th isNumeric>Trade</Th>
          <Th isNumeric>Settled</Th>
        </Tr>
      </Thead>
      <Tbody data-testid="rollup-table">
        {accountTypes.map(
          ({ accountType, convertedTradeBalance, convertedSettleBalance }) => (
            <Tr key={accountType}>
              <Td>{balancesEnumToLabel(accountType)}</Td>
              <Td isNumeric data-testid={`balance-${accountType}-trade`}>
                {getCurrencyValue(convertedTradeBalance)}
              </Td>
              <Td isNumeric data-testid={`balance-${accountType}-settled`}>
                {getCurrencyValue(convertedSettleBalance)}
              </Td>
            </Tr>
          )
        )}
        <Tr>
          <Td fontWeight="bold" borderBottom="0">
            Totals
          </Td>
          <Td
            isNumeric
            data-testid="balance-total-trade"
            fontWeight="bold"
            borderBottom="0"
          >
            {getCurrencyValue(grandTotalTrade, 2)}
          </Td>
          <Td
            isNumeric
            data-testid="balance-total-settled"
            fontWeight="bold"
            borderBottom="0"
          >
            {getCurrencyValue(grandTotalSettled, 2)}
          </Td>
        </Tr>
      </Tbody>
    </>
  );
}
